import Tray from './Tray.js'

export default Tray
